module.exports = __webpack_public_path__ + "images/category_lp/common/store_images/kurashi_no_kura_11fcf02eac6cef15319808a4104adcdb.png";